import { RECAPTCHA_ACTION } from '@/common/constants';

const getRecaptchaToken = () =>
  new Promise((resolve, reject) =>
    window.grecaptcha.ready(() =>
      window.grecaptcha
        .execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY, {
          action: RECAPTCHA_ACTION,
        })
        .catch(reject)
        .then(resolve),
    ),
  );

export default getRecaptchaToken;
